import { WlWindow } from 'typings/globals/cordova';

import {
  BusinessEvent,
  BusinessEventHandler,
  TripPaid,
} from '../../businessLayer';
import { fireOnce } from '../helpers';

declare const window: WlWindow;

// SEE https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#measure_checkouts
// for event details
export const googleDataLayerListener: BusinessEventHandler = (
  evt: BusinessEvent,
) => {
  console.log(
    '[GoogleDataLayer] received event',
    evt.type,
    evt,
    evt.constructor.name,
  );
  if (evt.type === 'TripPaid') {
    const tripPaid = evt as TripPaid;
    fireOnce(`tripPaid.${tripPaid.trip.id}`, () => {
      window?.gtag('event', 'tripPaid', { trip: tripPaid.trip });
    });
  }
};
